var padDate = function (value) {
  return value < 10 ? '0' + value : value
}

export const qnImageWBlurWater=(url, w, isBlur,x=20,y=20)=>{
  var blurUmp = isBlur?'/blur/'+x+'x'+y+'':''
  return url + "?imageMogr2/thumbnail/"+w+'x' + blurUmp+"|watermark/4/text/6Iif5bGx5a-555qE5Lq6/font/5a6L5L2T/fontsize/1000/fill/Z3JheQ==/dissolve/30/rotate/40/uw/400/uh/250/resize/1";
}

export const dateFormat = (timestamp, format) => {
  var date = new Date(timestamp)
  var year = date.getFullYear()
  var month = padDate(date.getMonth() + 1)
  var day = padDate(date.getDate())
  var hours = padDate(date.getHours())
  var minutes = padDate(date.getMinutes())
  var seconds = padDate(date.getSeconds())
  let week = new Date(timestamp).getDay()
  let weeks = ['日', '一', '二', '三', '四', '五', '六']
  let getWeek = '星期' + weeks[week]
  return year + '-' + month + '-' + day
}



// WEBPACK FOOTER //
// ./src/utils/utils.js